import { render, staticRenderFns } from "./assign-product-dialog.vue?vue&type=template&id=415db49e&"
import script from "./assign-product-dialog.vue?vue&type=script&lang=js&"
export * from "./assign-product-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports